<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block class="main-test-ucsearchentityerp">
    <p>Permite realizar búsqueda de entidades</p>
    <div class="container">
      <UCSearchEntityERP
        placeholder="Código…"
        search-text="Buscando trabajadores…"
        search-cancellation-text="Búsqueda trabajadores cancelada…"
        search-not-found-text="Trabajador no encontrado…"
        :end-point-for-code-search="WorkerSearchText"
        :end-point-for-list="WorkerList"
        :property-entity-shown-input="['Codigo', 'Sujeto.NombreSujeto']"
        :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
        :property-entity-shown-list-subtitle="['Codigo']"
      />
    </div>
    <p>Con barra de paginación en el popup:</p>
    <div class="container">
      <UCSearchEntityERP
        placeholder="Código…"
        search-text="Buscando trabajadores…"
        search-cancellation-text="Búsqueda trabajadores cancelada…"
        search-not-found-text="Trabajador no encontrado…"
        :end-point-for-code-search="WorkerSearchText"
        :end-point-for-list="WorkerList"
        :property-entity-shown-input="['Codigo', 'Sujeto.NombreSujeto']"
        :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :show-pagination-bar="true"
      />
    </div>
  </f7-block>
</template>

<script>
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import APIErp from '@/js/services/APIErp';

export default {
  name: 'TestUCSearchEntityERP',
  components: {
    UCSearchEntityERP,
  },
  methods: {
    WorkerSearchText(params) {
      return APIErp.callWorkerSearchText(params);
    },
    WorkerList() {
      return APIErp.callWorkerList();
    },
  },
};
</script>

<style lang="scss">
.main-test-ucsearchentityerp {
  .container {
    margin: auto;
    width: 75%;
  }
}
</style>
